import api from './api';

export const submitResponse = (data) => api.post('/api/responses', data);
export const getResponses = (params) => api.get('/api/responses', { params });
export const getMyResponses = (params) => api.get('/api/responses/mine', { params });
